import { DefinirPlanoPagamentoResposta } from "app/api/classes/OrcamentoApi";
import microuniversoApi from "app/api/microuniversoApi";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { WindowMU } from "app/types/WindowMU";
import * as R from 'ramda'

declare var window:WindowMU

function atualizarEstados(dadosPlanoPagamento: DefinirPlanoPagamentoResposta)  {
    const orcamentoLegado = window.orcamentoController.model

    store.dispatch(sobrescreverInformacoesAction(R.pick([
        "UtilizaPlanoPagamento",
        "CodigoPlanoPagamento",
        "CodigoDocumentoPlanoPagamento",
        "NomeDocumentoPlanoPagamento",
        "CodigoDocumentoEntrada",
        "ValorEntrada"
    ], dadosPlanoPagamento)))

    store.dispatch(sobrescreverInformacoesAction({
        CodigoParcelaPlanoPagamento: dadosPlanoPagamento.CodigoParcela,
        CodigoCarenciaPlanoPagamento: dadosPlanoPagamento.CodigoCarencia,
        PlanoPagamentoComEntrada: dadosPlanoPagamento.ComEntrada,
        NomeDocumentoEntrada: dadosPlanoPagamento.NomeDocumentoPlanoPagamento

    }))
}

export async function definirPlanoPagamento({codigoPlanoPagamento}:{codigoPlanoPagamento:string}) {
    const dadosPlanoPagamento = await microuniversoApi.Orcamento.definirPlanoPagamento(
        store.getState().orcamento.IdentificadorOrcamento,
        codigoPlanoPagamento
    )

    atualizarEstados(dadosPlanoPagamento)

    
}

export async function definirParcelaPlanoPagamento({codigoNumeroParcelas}:{codigoNumeroParcelas:number}) {
    const  dadosPlanoPagamento = await microuniversoApi.Orcamento.definirParcelaPlanoPagamento(
        store.getState().orcamento.IdentificadorOrcamento,
        codigoNumeroParcelas
    )

    atualizarEstados(dadosPlanoPagamento)
}

export async function definirCarenciaPlanoPagamento({codigoCarencia}:{codigoCarencia:number}) {
    const dadosPlanoPagamento = await microuniversoApi.Orcamento.definirCarenciaPlanoPagamento(
        store.getState().orcamento.IdentificadorOrcamento,
        codigoCarencia
    )

    atualizarEstados(dadosPlanoPagamento)
}

export async function gerarParcelasPlanoPagamento(input:GerarParcelasPlanoPagamentoInput) {
    const dadosPlanoPagamento = await microuniversoApi.Orcamento.gerarParcelasPlanoPagamento(
        store.getState().orcamento.IdentificadorOrcamento,
        input)

    atualizarEstados(dadosPlanoPagamento)
}

export async function removerPlanoPagamento({identificadorOrcamento}:{identificadorOrcamento:string}) {
    const dadosPlanoPagamento = await microuniversoApi.Orcamento.removerPlanoPagamento(identificadorOrcamento)

    atualizarEstados(dadosPlanoPagamento)
}

export type GerarParcelasPlanoPagamentoInput = {
    CodigoPlanoPagamento?: number;
    CodigoParcela?: number;
    CodigoCarencia?: number;
    ComEntrada?:boolean
    ValorEntrada?:number
    CodigoDocumentoEntrada?:number
}